import React from 'react';
import PropTypes from 'prop-types';

class StatusBox extends React.Component {
  static propTypes = {
    status: PropTypes.string,
  };
  static defaultProps = {
    status: 1,
    text: '',
  };
  render() {
    return (
      <div className={`status-box status-${this.props.status}`}>
        <span>{this.props.text}</span>
      </div>
    );
  }
}

export default StatusBox;



// WEBPACK FOOTER //
// ./src/components/elements/StatusBox.js